var App = App || {};

App.NavigationMenu = (function ($) {
    return {
        init: init,
        onParentNodeClick: onParentNodeClick
    };

    function init() {
        initDefaultSetup();
        initTreeListToggle();
    }

    function initDefaultSetup() {
        var $currentNavTreeLink = $('.js-nav-tree a[href="' + window.location.pathname + '"]');
        var $topLevelTreeList = $currentNavTreeLink.closest('[role="tree"]');

        var $parentNavTreeLists = $currentNavTreeLink.parents('.js-nav-tree-sublist');
        var $parentNavTreeItems = $parentNavTreeLists.closest('.js-nav-tree-item');
        var $parentNavTreeToggles = $parentNavTreeItems.children('.js-nav-tree-toggle');
        var $parentNavTreeScreenReaders = $parentNavTreeToggles.find('.screenreader-text');
        var $parentNavTreeLinks = $parentNavTreeItems.children('.js-nav-tree-link');

        $currentNavTreeLink.addClass('ss-currentPage');
        $currentNavTreeLink.attr('tabindex', '0');
        $currentNavTreeLink.attr('aria-current', 'true');

        $topLevelTreeList.attr('tabindex', '-1');

        if ($parentNavTreeLists.length) {
            $parentNavTreeLists.addClass('open');
            $parentNavTreeToggles.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
            $parentNavTreeScreenReaders.text('Collapse');
            $parentNavTreeLinks.attr('aria-expanded', 'true');
        }
    }

    function initTreeListToggle() {
        $('[data-tree-type="navigation-menu"] .js-nav-tree-toggle').on('click', function (e) {
            e.preventDefault(); // stop button from submitting the page form
            var $currentNavTreeLink = $(e.target).siblings('.js-nav-tree-link').first();
            onParentNodeClick($currentNavTreeLink);
        });
    }

    function onParentNodeClick($currentNavTreeLink) {
        var $currentNavTreeToggle = $currentNavTreeLink.siblings('.js-nav-tree-toggle').first();
        var $currentNavTreeScreenReader = $currentNavTreeToggle.find('.screenreader-text').first();
        var $navTreeSublist = $currentNavTreeToggle.siblings('.js-nav-tree-sublist').first();
        var $navTreeLink = $currentNavTreeToggle.siblings('.js-nav-tree-link').first();

        $currentNavTreeToggle.toggleClass('icon-general-arrow-filled-right icon-general-arrow-filled-down');
         
        $navTreeSublist.toggleClass('open');

        if ($navTreeSublist.hasClass('open')) {
            $navTreeLink.attr('aria-expanded', 'true');
            $currentNavTreeScreenReader.text('Collapse');
        } else {
            $navTreeLink.attr('aria-expanded', 'false');
            $currentNavTreeScreenReader.text('Expand');
        }
    }
})(jQuery);